/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */

// eslint-disable-next-line jira/import-whitelist
import memoizeOne from 'memoize-one';
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import { getNavigationUiState } from './getNavigationUiState.tsx';

const getNavigationUiStateMemoized = memoizeOne((atlassianAccountId) =>
	getNavigationUiState({ tenantContext: { atlassianAccountId } }),
);
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const navigationUiStateResource: RouteResource<any> = createResource<any>({
	type: 'RESOURCE_TYPE_NAVIGATION_UI',
	getKey: () => 'state',
	getData: async (_, { tenantContext: { atlassianAccountId } }) =>
		getNavigationUiStateMemoized(atlassianAccountId),
	maxAge: Infinity,
	isCritical: true,
});
